/**
 * Returns true if in Author mode's ContentFrame iframe
 * @returns {boolean}
 */
export const isInContentFrame = (): boolean => {
  try {
    // if in iframe
    if (window.self !== window.top) {
      return window.frameElement!.id === "ContentFrame";
    }
    return false;
  } catch (_e) {
    return false;
  }
};
